import styled, {css} from "styled-components"

import {Hr, Card} from "@irati/ui/src/Layout"
import Icon from "@irati/ui/src/Icon"
import {Input} from "@irati/ui/src/FormItem"
import Flex from "@irati/ui/src/Flex"
import {H5, Label} from "@irati/ui/src/Typography"

import flexiPoints from "../../../images/flexi_points.svg"
import eap from "../../../images/eap.svg"

interface InputProps {
  isError: boolean
}

interface ChipProps {
  fillColor?: string
}

interface CustomCard {
  isSelected?: boolean
}

export const Container = styled(Flex)`
  background-color: ${({theme}) => theme.colors.greys.lightest};
`

export const CustomChip = styled.div<ChipProps>`
  ${({theme, fillColor}) => `
    background-color: ${theme.colors.greys.lightest};
    padding: ${theme.spacing.one};
    border-radius: 6px;
    cursor: default;
    font-family: ${theme.font.light};
    line-height: 16px;
    font-size: 14px;
    color: ${theme.colors.primary2};
    path {
      fill: ${fillColor || theme.colors.greys.white}
    }
  `}
`

export const StyledHr = styled(Hr)`
  width: 97%;
  margin-top: 0px;
  margin-bottom: 0px;
`

export const StyledInput = styled(Input)<InputProps>`
  margin-bottom: 0px;
  .col-xs-12 {
    padding-right: 0px;
  }
  ${({isError, theme}) => css`
    ${isError &&
    `
      .col-xs-12 {
        .form-control {
          border-color: ${theme.colors.tertiary.r_400};
          box-shadow: 0 0 2px 0 ${theme.colors.tertiary.r_400};
        }
      }

    `}
  `}
`

export const StyledIcon = styled(Icon)`
  path:last-child {
    fill: ${({theme}) => theme.colors.greys.white};
  }
`

export const CustomCard = styled(Card)<CardProps>`
  ${({theme, isSelected}) => `
  flex: 1 1 0;
    cursor: pointer;
    border-radius: 6px;
    border: 2px solid ${isSelected ? theme.colors.secondary1 : "transparent"};
`}
`

export const StyledH5 = styled(H5)`
  font-family: ${({theme}) => theme.font.light};
`

export const StyledLabel = styled(Label)`
  font-size: 14px;
`

export const FlexiPointsImg = styled.img.attrs({
  src: flexiPoints,
  alt: "Flexi Points"
})``

export const EAPImg = styled.img.attrs({
  src: eap,
  alt: "EAP"
})``
